import React from "react";

function Contact() {
  return (
    <div className="p-10">
      <h2 className="text-3xl font-bold text-blue-900 mb-4">Contact Us</h2>
      <p>📍 Location: Kphb Colony, Hyderabad, India</p>
      <p>📞 Phone: +91 7382233662</p>
      <p>📧 Email: raj5823p@gmail.com</p>
    </div>
  );
}

export default Contact;
